var CompareTableConfigurationService = (function () {
    function CompareTableConfigurationService($http) {
        this.$http = $http;
    }
    CompareTableConfigurationService.prototype.get = function () {
        return this.$http
            .get('compatibilityguide/ng-settings/feature/compare/sections')
            .then(function (response) { return response.data || []; });
    };
    CompareTableConfigurationService.$inject = ['$http'];
    return CompareTableConfigurationService;
}());
export { CompareTableConfigurationService };
